export const _setStartingMonday = (state, action) => {
  state.startingMonday = action.payload;
};

export const _setMonth = (state, action) => {
  state.Month = action.payload;
};

export const _setCbpProvider = (state, action) => {
  state.provider = action.payload;
};

export const _setSearchCbp = (state, action) => {
  state.searchCbp = action.payload;
};